import type { CSSProperties } from 'react';

import { TOG } from './columnDefs/fertilizationCols';

/**
 * Domain colouring shared by the Live and Temp embryo tables.
 *
 * These stayed byte-identical in both grids for long enough to drift, so they
 * live here rather than in the reusable table component — the colours encode
 * freeze business rules, not table behaviour.
 */
export function freezeMethodStyle(
  value: string | null,
): CSSProperties | undefined {
  if (!value) return undefined;
  if (value.includes('Glycerol'))
    return { backgroundColor: TOG.blue, color: 'white' };
  if (value.includes('Vitrification'))
    return { backgroundColor: TOG.darkBlue, color: 'white' };
  if (value !== '1.5M EG with suc')
    return { backgroundColor: TOG.red, color: 'white' };
  return undefined;
}

export function caneStyle(option: number | null): CSSProperties {
  if (option === 1) return { backgroundColor: TOG.green, fontWeight: 700 };
  if (option === 2) return { backgroundColor: TOG.orange, fontWeight: 700 };
  return { fontWeight: 700 };
}
